module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HVJG8B.acb5febf.jpg";